import { ChannelType as FbChannelType } from "../../../flatbuffers/generated/archive/channel-type";
import {
  validateIpAndPortString,
  validateDoubleIpAndPortString,
  validateDoubleHostAndPortString,
} from "../../../utils/utils";

/**
 * Whether a channel's socket addresses are valid for its connection type.
 *
 * TCP, UDP and SERIAL are unchanged from the form's original inline checks.
 * ADAPTER channels have no socket of their own — the vendor connection lives
 * elsewhere (e.g. a controller board's own serial port, carried on the CDO
 * mapping, not the channel) — so an ADAPTER channel's sockets are always
 * valid regardless of what is or is not filled in.
 */
export function channelSocketsValid(channel: {
  connectionType: FbChannelType;
  routableSocketAddress?: string | Uint8Array | null;
  vendorSocketAddress?: string | Uint8Array | null;
}): boolean {
  if (channel.connectionType === FbChannelType.TCP) {
    const hasSocket = validateIpAndPortString(String(channel.routableSocketAddress ?? ""));
    const hasVendorSocket = validateIpAndPortString(String(channel.vendorSocketAddress ?? ""));
    return hasSocket || hasVendorSocket;
  }
  if (channel.connectionType === FbChannelType.UDP) {
    return validateDoubleIpAndPortString(String(channel.routableSocketAddress ?? ""));
  }
  if (channel.connectionType === FbChannelType.SERIAL) {
    const hasSocket = validateDoubleHostAndPortString(String(channel.routableSocketAddress ?? ""));
    const hasVendorSocket = validateDoubleHostAndPortString(
      String(channel.vendorSocketAddress ?? ""),
    );
    return hasSocket || hasVendorSocket;
  }
  if (channel.connectionType === FbChannelType.ADAPTER) {
    return true;
  }
  return false;
}

export default channelSocketsValid;
